import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';

const NewsIcon = ({ size = 22, color = 'currentColor', className }) => (
  <FontAwesomeIcon
    icon={faNewspaper}
    className={className}
    style={{ fontSize: size, color, width: '1em', height: '1em' }}
  />
);

export default NewsIcon;
